import TimesheetPayload from './timesheetPayload'

export default class ModifyTimesheetPayload extends TimesheetPayload {
  constructor({
    bookingId,
    candidateId,
    locationId,
    operationType,
    startTimeLocal,
    endTimeLocal,
    payOptionType,
    breakMinutes,
    newStartTimeLocal,
    newEndTimeLocal,
    newPayOptionType,
    newBreakMinutes,
  } = {}) {
    super({
      bookingId,
      candidateId,
      locationId,
      operationType,
      startTimeLocal,
      endTimeLocal,
      payOptionType,
      breakMinutes,
    })
    /**
     * @type {String}
     */
    this.newStartTimeLocal = newStartTimeLocal

    /**
     * @type {String}
     */
    this.newEndTimeLocal = newEndTimeLocal

    /**
     * @type {String}
     */
    this.newPayOptionType = newPayOptionType

    /**
     * @type {Number}
     */
    this.newBreakMinutes = newBreakMinutes
  }
}
